<template>
    <div>
        <!--网销单详情 貌似这个页面不用了-->
        <Card :bordered="false" dis-hover>
            <p slot="title">网销单详情</p>
            <ButtonGroup shape="circle" slot="extra">
                <Button type="primary" @click="point()">
                    打印
                </Button>
            </ButtonGroup>
            <Row>
                <Col span="8"><strong>客户：</strong> <span class="result">{{Name}}</span></Col>
                <Col span="8"><strong>总金额：</strong> <span class="result">￥{{purchase.money}}</span></Col>
                <Col span="8"><strong>本单欠款：</strong> <span class="result">￥{{purchase.nomoney}}</span></Col>
                <Col span="8"><strong>门店：</strong> <span class="result">{{storename}}</span></Col>
                <Col span="8"><strong>总数量：</strong> <span class="result">{{purchase.total}}</span></Col>
                <Col span="8"><strong>往期欠款：</strong> <span class="result">￥{{purchase.lastNomoney}}</span></Col>
                <Col span="8"><strong>业务员：</strong> <span class="result">{{purchase.adminName}}</span></Col>
                <Col span="8"><strong>实收合计：</strong> <span class="result">￥{{purchase.paymoney}}</span></Col>
                <Col span="8"><strong>合计欠款：</strong> <span class="result">￥{{purchase.totalNomoney}}</span></Col>
                <Col span="8"><strong>结算账户：</strong> <span class="result">{{bankname}}</span></Col>
                <Col span="8"><strong>抹零金额：</strong> <span class="result">￥{{purchase.removemoney}}</span></Col>
                <Col span="8"><strong>制单日期 ：</strong> <span class="result">{{purchase.time}}</span></Col>
                <Col span="8"><strong>单号：</strong> <span class="result">{{purchase.markcode}}</span></Col>
                <Col span="8"><strong>优惠金额：</strong> <span class="result">￥{{purchase.discountsmoney}}</span></Col>
                <Col span="8"><strong>收货信息 ：</strong> <span class="result"> {{purchase.username}},{{purchase.phone}},{{purchase.shoppingaddress}}</span></Col>
                <Col span="24"><strong>客户留言：</strong> <span class="result">{{purchase.remark}}</span></Col>
            </Row>
        </Card>
         <table slot="content" class="ive-table" v-for="(item, index) in purchase.goodslist" :key="index">
            <thead>
            <th>商品详情</th>
            <th>名称/货号</th>
            <th>规格/颜色</th>
            <th>单价</th>
            <th>数量</th>

            </thead>
            <tbody>
            <tr align="center" v-for="(k,v) in purchase.goodslist[index].goodsItem">
                <td width="300" :rowspan="v" v-if="v==0">
                    <Fy-Img
                            class="img"
                            :ImgSrc="item.goodsimg | filtImg(item.goodsimg )"
                            :Width="100"
                            :Height="100"
                    ></Fy-Img>
                </td>
                <td>{{item.goodsname}} / {{item.goodscode}}</td>
                <td>{{k.size}} / {{k.color}}</td>
                <td>{{k.lprice}}</td>
                <td>{{k.quantity}}</td>
             </tr>
            </tbody>
        </table>
        <div id="qrcodebox" style="display:none"></div>
        <div id="wetTwoCode" style="display:none"></div>
    </div>
</template>
<script>
    import {getLodop} from '@js/LodopFuncs'
    import QRCode from 'qrcodejs2'  
import { setTimeout } from 'timers';
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                Name:'',
                bankname:'',
                phone:'',
                storename:JSON.parse(localStorage.getItem('shop')).name,
                purchase:{}
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getMarketAppletCode(this.$route.query.appletCode)
        },

        methods: {
            //获取采购单
            getMarketAppletCode(id){
                this.$Api.getMarketAppletCode({
                    appletCode:id
                }).then(res => {
                    if(res.code==200){
                        this.purchase = res.data
                        this.Name=res.data.customer.name
                        this.bankname = res.data.bankmarket[0].bankname

                        if(res.data.shoppingaddress==null){
                            this.phone =  res.data.username +','+ res.data.customer.phone+','+自提
                        }else{
                            this.phone =  res.data.username +','+ res.data.customer.phone+','+res.data.shoppingaddress
                        }
                       
                        this.setQRCode()
                        
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
             
            setQRCode(){
                document.getElementById("qrcodebox").innerHTML=''
                document.getElementById("wetTwoCode").innerHTML=''
                var a = new QRCode('qrcodebox', {  
                    width: 100,  
                    height: 100,  
                    text: this.purchase.qrcode   
                })  
                new QRCode('wetTwoCode', {  
                    width: 100,  
                    height: 100,  
                    text: this.purchase.wetTwoCode  
                })  
            },

            /**
             * 打印
             * */
            point(){
                //打印类型   4=80  5=110  1，2,3=针式
                var resultPrint = this.common.isSelectPrint(this,localStorage.getItem('setpointSize'))
                //是否选择的云打印机  
                var resultPrintCloud = this.common.isSelectPrint(this,localStorage.getItem('yuntext'))
                if(!resultPrint||resultPrint==''||resultPrint=='null'|| resultPrint=='undefined'){
                    return;
                }
                if(resultPrintCloud != "" && resultPrintCloud != "null" && resultPrintCloud != null){ //云打印机
                    /**
                     ** cid,
                     * sid,
                     * 订单id
                     * 打印机设备码
                     * 类型
                     * 标题
                     **/
                    let isEasy = JSON.parse(localStorage.getItem('shop')).isEasy
                    let isTable = JSON.parse(localStorage.getItem('shop')).isTable
                    let selectPaper = JSON.parse(localStorage.getItem('setpointSize'))
                    if(selectPaper == 5){
                        selectPaper = "110mm";
                    }else if(selectPaper == 4){
                        selectPaper = "80mm";
                    }else if(selectPaper == 1 || selectPaper == 2 || selectPaper == 3){
                        selectPaper = "针式";
                    }else{
                        this.$Message.warning("请到右上角点击用户进入个人中心设置打印类型");
                        return false;
                    }
                    this.common.CloudPrint(
                        this,this.cid,this.sid,this.$route.query.id,resultPrintCloud,
                        0, '销售单',isEasy,selectPaper,
                        isTable
                        )
                    return;
                }

                var LODOP = getLodop();
                /**
                 * result返回值说明
                 * 123 - 针式打印机的等分选择
                 * 4   -   80MM的打印机
                 * 5   -   110MM的打印机
                 * **/






                var orderType=JSON.parse(localStorage.getItem('shop')).name+'网销单'
                 //客户：
                var username= this.purchase.customer.name
                //销售员
                var adminName = this.purchase.adminName
                //制单员
                var zdName= JSON.parse(localStorage.getItem('adminUser')).name  
                //单号：
                var markcode = this.purchase.markcode
                //业务日期
                var zdtime = this.purchase.time
                //模板返回数据
                var resData = ''
                this.purchase.printNames.forEach(item=>{
                    resData = resData+'<div style="display:inline-block;width:49%">'+item+'</div>'
                })
                //收货地址：
                var address= this.phone
                if(address==null){  address='自提'  }
                //联系方式  
                var phone = JSON.parse(localStorage.getItem('shop')).phone
                //联系地址：
                var lxaddress= JSON.parse(localStorage.getItem('shop')).address  
                //商品金额
                var countmoney = this.purchase.money
                //商品总件数
                var count=this.purchase.total


                //备注
                var printRemark=this.purchase.printRemark
                if(printRemark==null){
                    printRemark=''
                }else{
                    printRemark='<li>温馨提示：'+printRemark+'</li>'
                }

                //模板二维码
                var qrcoderemark = this.purchase.qrcoderemark
                var qrcodeImg = document.getElementById("qrcodebox").getElementsByTagName('img')[0]
                var qrcoresult=''
                if(qrcoderemark==null){
                        qrcoresult=''
                } else{
                    /*if(strPName.search("Jolimark 24-pin printer") != -1 || strPName.search("DASCOM DS-19") != -1) { // 针式打印机
                        qrcoresult ='<div><img style="width: 105pt" src='+qrcodeImg.src+'  /><p>'+qrcoderemark+'</p></div>'
                    }else {
                        qrcoresult ='<div><img src='+qrcodeImg.src+'  /><p>'+qrcoderemark+'</p></div>'
                    }*/
                    qrcoresult ='<div><img src='+qrcodeImg.src+'  /><p>'+qrcoderemark+'</p></div>'
                }
                //小程序二维码  
            
                var wetTwoCode = document.getElementById("wetTwoCode").getElementsByTagName('img')[0]
                var getwetTwoCode = this.purchase.wetTwoCode
                if(getwetTwoCode==null){
                        getwetTwoCode=''
                }else{
                    /*if(strPName.search("Jolimark 24-pin printer") != -1 || strPName.search("DASCOM DS-19") != -1) { // 针式打印机
                        getwetTwoCode='<div><img  style="width: 105pt"  src='+wetTwoCode.src+' /><p>商城</p></div>'
                    }else {
                        getwetTwoCode='<div><img src='+wetTwoCode.src+' /><p>商城</p></div>'
                    }*/
                    getwetTwoCode='<div><img src='+wetTwoCode.src+' /><p>商城</p></div>'
                }

                var strTr=''
                this.purchase.goodslist.forEach((item,index)=>{
                    item.goodsItem.forEach((k,v)=>{
                        strTr=strTr+'<tr><td>'+item.goodsname+'/'+item.goodscode+'</td><td>'+k.size+'/'+k.color+'</td><td>'+k.quantity+'</td><td>'+k.lprice+'</td><td>'+item.lprice*k.quantity+'</td></tr>'
                    })
                })
                var strTable='<table><tr><td style="width: 26%">商品/货号</td><td  style="width: 26%">规格/颜色</td><td >数量</td><td >金额</td><td>小计</td></tr>'+strTr+'</table>';
                /** 修改打印机的css **/
                var strStyles=''

                // 如果resultPrint==1 2 3 添加针式打印机样式，别问为啥，就这样做
                if( resultPrint==1 || resultPrint==2 || resultPrint==3 ){
                    strStyles=""
                    strStyles="<style>table tr td{border: 1pt solid #000000; border-collapse:collapse;}#count{border: 1pt solid #000000; border-top: 0;width: 95.8%; margin-left: 1.5pt} </style>"
                }else {
                    strStyles=''
                }
                var strStyle="<style>  *{margin: 0;padding: 0;}#contentse{font-size:9pt;}#title{font-size: 16pt;text-align: center}table{width: 100%;margin-top: 5pt;}" +
                    "table tr td{height: 16pt;border-top:1pt #000000 dashed;white-space:normal; word-break:break-all;padding-right: 5pt}#title{ text-align: center; padding-top: 10pt; }" +
                    ".list {list-style: none;  line-height: 10pt; }" +
                    "#zds{width: 100%; margin:10pt auto;height: 50pt;text-align: center}" +
                     ".codebox{width: 100%;}.codebox div{display:inline-block;width:50%;text-align:center}.codebox div img{display:block;margin:10pt auto}" +
                    "#count{padding:5pt 10pt 5pt 0;margin-bottom: 5pt; border-top:1pt #000000 dashed;border-bottom:1pt #000000 dashed;}</style>"
                var time=LODOP.FORMAT("TIME:yyyy-mm-dd hh:mm:ss","now");//获取当前的时间
                var str=strStyle+strStyles+'<section id="contentse"><p id="title">'+orderType+'</p> ' +
                    '<ul class="list"><li>客户：'+username+'</li>' +
                    '<li>销售员：'+adminName+'</li>' +
                    '<li>制单员：'+zdName+'</li>' +
                    '<li>单号：'+markcode+'</li>' +
                    '<li>业务日期：'+zdtime+'</li>' +
                    '</ul>'+
                    strTable+
                    '<p id="count">合计：'+count+'<span style="float:right;padding-right: 20pt">商品金额：RMB '+countmoney+'</span></p>'+
                    resData+
                    '<ul class="list">'+ 
                    '<li>收货地址：'+address+'</li>' +
                    '<li>打印时间：'+time+'</li>' +
                    '<li>联系方式：'+phone+'</li>' +
                    '<li>联系地址：'+lxaddress+'</li>' +
                    '<li>备注：'+printRemark+'</li>' +
                    '</ul>'+
                    '<div class="codebox">'+qrcoresult+getwetTwoCode+'</div>' +
                    '<p id="zds">掌大师，轻松管理每一天。客服热线:400-801-6580<br>下载即可使用的进销存</p></section>'
                    this.Printing(LODOP,str)
            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>